import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { CartContext } from 'components/cart';
import classNames from 'lib/classNames';

const RandomText = (props) => {
	const { campaign, cart_settings, Utils } = useContext(CartContext);
	const { random_text } = Utils.getModules(campaign, cart_settings);

	if (!random_text.active) return null;
	return (
		<div className={classNames('py-3 px-5 adapt-images')}>
			<div
				dangerouslySetInnerHTML={{
					__html: random_text.text,
				}}
			></div>
		</div>
	);
};

RandomText.propTypes = {};

export default RandomText;
